<script setup lang="ts">
defineProps<{
    content: Record<string, string | null>;
}>();
</script>

<template>
    <footer class="bg-foreground px-4 py-16 md:px-20">
        <div class="mx-auto max-w-[1280px]">
            <div
                class="flex flex-col gap-8 md:flex-row md:items-start md:justify-between"
            >
                <!-- Left column -->
                <div>
                    <!-- Logo -->
                    <img
                        src="/images/landing/logo.svg"
                        alt="Rate Your Hearing - powered by Resonate"
                        class="mb-6 h-[62px] w-[279px] md:h-[60px] md:w-[270px]"
                    />

                    <!-- Contact (mobile only, shown before social icons) -->
                    <div class="mb-8 md:hidden">
                        <p class="text-base font-medium text-accent">Contact</p>

                        <a
                            :href="content['footer.contact.phone.href'] ?? ''"
                            class="mt-2 block text-[32px] leading-[48px] font-medium text-white"
                        >
                            {{ content['footer.contact.phone.label'] }}
                        </a>
                    </div>

                    <!-- Social icons -->
                    <div class="mb-8 flex gap-3">
                        <a
                            :href="content['footer.social.youtube_href'] ?? ''"
                            aria-label="Find us on YouTube"
                        >
                            <img
                                src="/images/landing/social-youtube.svg"
                                alt="YouTube"
                                class="size-12"
                            />
                        </a>
                        <a
                            :href="content['footer.social.facebook_href'] ?? ''"
                            aria-label="Find us on Facebook"
                        >
                            <img
                                src="/images/landing/social-facebook.svg"
                                alt="Facebook"
                                class="size-12"
                            />
                        </a>
                        <a
                            :href="content['footer.social.instagram_href'] ?? ''"
                            aria-label="Find us on Instagram"
                        >
                            <img
                                src="/images/landing/social-instagram.svg"
                                alt="Instagram"
                                class="size-12"
                            />
                        </a>
                        <a
                            :href="content['footer.social.email_href'] ?? ''"
                            aria-label="Send us an email"
                        >
                            <img
                                src="/images/landing/social-email.svg"
                                alt="Email"
                                class="size-12"
                            />
                        </a>
                    </div>

                    <!-- Email (mobile only) -->
                    <a
                        :href="content['footer.contact.email.href'] ?? ''"
                        class="mb-8 block text-xl text-white md:hidden"
                    >
                        {{ content['footer.contact.email.label'] }}
                    </a>

                    <!-- Disclaimer -->
                    <p class="max-w-[530px] text-sm leading-6 text-[#929699]">
                        {{ content['footer.disclaimer'] }}
                    </p>
                </div>

                <!-- Right column (desktop only) -->
                <div class="hidden text-right md:block">
                    <p class="text-base font-medium text-accent">Contact</p>

                    <a
                        :href="content['footer.contact.phone.href'] ?? ''"
                        class="mt-4 block text-[32px] leading-[48px] font-medium text-white"
                    >
                        {{ content['footer.contact.phone.label'] }}
                    </a>

                    <a
                        :href="content['footer.contact.email.href'] ?? ''"
                        class="mt-4 block text-sm text-white"
                    >
                        {{ content['footer.contact.email.label'] }}
                    </a>
                </div>
            </div>

            <!-- Bottom bar -->
            <div
                class="mt-8 flex flex-col gap-2 border-t border-white/10 pt-6 text-sm text-[#A5A6A7] md:mt-16 md:flex-row md:items-center md:justify-between"
            >
                <p>{{ content['footer.copyright'] }}</p>
                <div class="flex flex-col gap-2 md:flex-row md:gap-8">
                    <a
                        :href="content['footer.privacy_href'] ?? ''"
                        class="transition-colors hover:text-white"
                        >Privacy Policy</a
                    >
                    <a
                        :href="content['footer.terms_href'] ?? ''"
                        class="transition-colors hover:text-white"
                        >Terms &amp; Conditions</a
                    >
                </div>
            </div>
        </div>
    </footer>
</template>
